var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('DashboardTilesPackage',{attrs:{"tiles":_vm.tiles,"currentUser":_vm.getCurrentUser,"currentCompany":_vm.getUserSchool}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }